// extracted by mini-css-extract-plugin
export default {"CompanyTopicAddItem":"company-topic-add-item_CompanyTopicAddItem__If3CW"};